import {IErrorResponseItem, ValidationError, ValidationErrors} from "../services/validator";
import { IAutomationFormState } from "../components/Settings/Automations/Form/AutomationForm";
import { AutomationType, CategoryAutomationAction, PaymentMethodAutomationAction } from "../config/automation";

export enum AutomationValidationField {
    TYPE = "AutomationRequest.Type",
    ACTION = "AutomationRequest.Action",
    
    PAYMENT_METHOD = "AutomationRequest.PaymentMethodID",
    SHARE_WITH_FRIENDS_NAME = "AutomationRequest.Split.Name",
    SHARE_WITH_FRIENDS_AMOUNT = "AutomationRequest.Split.Amount",
    SHARE_WITH_FRIENDS_PERCENTAGE = "AutomationRequest.Split.Percentage",

    CATEGORY = "AutomationRequest.CategoryID",
    BUDGET = "AutomationRequest.BudgetID"
}

export type AutomationsValidation = {
    [key in AutomationValidationField]?: ValidationError[];
};

export type AutomationsValidationErrors = ValidationErrors<AutomationsValidation, AutomationValidationField>;

export const automationValidationFactory = (errors: IErrorResponseItem[]): AutomationsValidationErrors => {
    const v = new ValidationErrors<AutomationsValidation, AutomationValidationField>();
    v.setMap({
        type: AutomationValidationField.TYPE,
        action: AutomationValidationField.ACTION,

        paymentMethodId: AutomationValidationField.PAYMENT_METHOD,
        split_name: AutomationValidationField.SHARE_WITH_FRIENDS_NAME,
        split_amount: AutomationValidationField.SHARE_WITH_FRIENDS_AMOUNT,
        split_percentage: AutomationValidationField.SHARE_WITH_FRIENDS_PERCENTAGE,

        categoryId: AutomationValidationField.CATEGORY,
        category_budget: AutomationValidationField.BUDGET,
    });
    v.setErrors(errors);

    return v;
};

export const validateAutomationForm = (data: IAutomationFormState): AutomationsValidationErrors => {
    const errors = automationValidationFactory([]);

    if (!data.type) {
        errors.add(AutomationValidationField.TYPE, ValidationError.REQUIRED);
    }

    if (data.type === AutomationType.PAYMENT_METHOD) {
        if (!data.value.paymentMethodId) {
            errors.add(AutomationValidationField.PAYMENT_METHOD, ValidationError.REQUIRED);
        }
        if (!data.value.action) {
            errors.add(AutomationValidationField.ACTION, ValidationError.REQUIRED);
        }

        if (data.value.action === PaymentMethodAutomationAction.SHARE_WITH_FRIENDS_FIXED) {
            if (!data.value.payload.name) {
                errors.add(AutomationValidationField.SHARE_WITH_FRIENDS_NAME, ValidationError.REQUIRED);
            }
            if (!data.value.payload.amount || isNaN(data.value.payload.amount)) {
                errors.add(AutomationValidationField.SHARE_WITH_FRIENDS_AMOUNT, ValidationError.REQUIRED);
            }
        }
        if (data.value.action === PaymentMethodAutomationAction.SHARE_WITH_FRIENDS_PERCENTAGE) {
            if (!data.value.payload.name) {
                errors.add(AutomationValidationField.SHARE_WITH_FRIENDS_NAME, ValidationError.REQUIRED);
            }
            if (!data.value.payload.percentage || isNaN(data.value.payload.percentage)) {
                errors.add(AutomationValidationField.SHARE_WITH_FRIENDS_PERCENTAGE, ValidationError.REQUIRED);
            }
        }
    } else if (data.type === AutomationType.CATEGORY) {
        if (!data.value.categoryId) {
            errors.add(AutomationValidationField.CATEGORY, ValidationError.REQUIRED);
        }
        if (!data.value.action) {
            errors.add(AutomationValidationField.ACTION, ValidationError.REQUIRED);
        }

        if (data.value.action === CategoryAutomationAction.SET_BUDGET) {
            if (!data.value.payload.budget) {
                errors.add(AutomationValidationField.BUDGET, ValidationError.REQUIRED);
            }
        }
    }

    return errors;
};

export const convertFromResponse = (errors: IErrorResponseItem[]): AutomationsValidationErrors => {
    return automationValidationFactory(errors);
};
